module.exports = __webpack_public_path__ + "static/media/document.07c489ab.png";